import { BCMSRecord, ModalOpen, useGlobalController, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { Biller } from "model";
import React from "react";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import UIButton from "compid/ui/UIButton";

import "./styles.css";

/**
 * @function TurnOffEBillPage
 * @returns {React.Component}
 * @exported true
 * @description The first page for the turn off eBill workflow
 * @example
 * <TurnOffEBillPage />
 */
export default function TurnOffEBillPage(props) {
  const controller = useGlobalController();
  const navigate = useRoute();

  BCMSRecord.globalControllerFor([ Biller ], controller);
  // Get the id of the biller and initalize a biller instance
  const id = useParams().billerID ?? "0";
  const biller = Biller.initByID(id);

  return (
    <PageView className="turn-off-ebill-page">
      <p className="page-sub-header semi-bold-text">TURN OFF EBILL SERVICE</p>

      <PageLayoutContainer>
        <div className="flex-container flex-vertical flex-width all-center">
          <div className="flex-container flex-vertical upper-content-container">
            {/* This needs to match what biller they are canceling an ebill for */}
            <BillerView biller={ biller } />
          </div>

          <CenterColumnContainer>
            <p className="active-message"><b>Your eBill is active</b></p>
            <ButtonContainer className="form-button-container">
              <ModalOpen id="ConfirmTurnOffEBillModal" className="flex-width" data={ biller }>
                <UIButton className="secondary-button">Turn off eBill</UIButton>
              </ModalOpen>
              
              <UIButton className="primary-button" onClick={ () => navigate(-1) }>Done</UIButton>
            </ButtonContainer>
          </CenterColumnContainer>
        </div>
      </PageLayoutContainer>
    </PageView>
  )
}
